// extracted by mini-css-extract-plugin
export default {"wrapper":"Advantages_wrapper__cD+3O","container":"Advantages_container__pqEfF","p":"Advantages_p__rjgxf","cards":"Advantages_cards__iIN3p"};